// Copyright (c) 2021 Deere & Company

import * as fetchService from '../../../shared/services/fetch';

import {handleError} from '../../../shared/services/error-handlers';

const basePath = '/api';

export const getEntitlements = async userId => {

    const endPoint = `${basePath}/users/${userId}/entitlements`;
    const options = {
        cloudPreferred: true,
        endpointId: 'entitlements'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

};



// WEBPACK FOOTER //
// ./src/user/shared/repositories/entitlements.js